// extracted by mini-css-extract-plugin
export var actionText = "_nn-4";
export var container = "_nn-0";
export var leftSection = "_nn-1";
export var rightSection = "_nn-2";
export var settingsButton = "_nn-6";
export var settingsIcon = "_nn-7";
export var shortcut = "_nn-5";
export var shortcutGroup = "_nn-3";